<template>
  <div class="onboarding-layout">
    <menu-header />
    <main class="onboarding-main">
      <slot />
    </main>
  </div>
</template>

<script>
import MenuHeader from '@/components/Container/MenuHeader'

export default {
  name: 'OnboardingLayout',
  components: {
    MenuHeader
  }
}
</script>

<style lang="scss" scoped>
.onboarding-layout {
  min-height: 100vh;
  background-color: #f6f7f9;
  display: flex;
  flex-direction: column;
}

.onboarding-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/Onboarding/OnboardingLayout.vue